import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=a8c8ca92&scoped=true&"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=a8c8ca92&prod&lang=less&"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=a8c8ca92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c8ca92",
  null
  
)

export default component.exports